import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export const BlogList = ({ blogs }) => {
  return (
    <div className="blog-list-container">
      <Helmet>
        <title>Tüm Blog Yazıları - TR Assist | Yol Yardım, Sigorta ve Teknoloji İçerikleri</title>
        <meta name="description" content="TR Assist blog yazılarının tamamı. Yol yardım, sigorta, teknoloji, filo yönetimi, dijital dönüşüm ve daha fazlası hakkında uzman içerikler. Kurumsal yol yardım çözümleri, sigorta asistans hizmetleri ve sektör trendleri." />
        <meta name="keywords" content="TR Assist blog, yol yardım makaleleri, sigorta blog, teknoloji, filo yönetimi, kurumsal yol yardım, sigorta asistans, dijital dönüşüm, ISO kalite yönetimi, çağrı merkezi entegrasyonu, veri analitiği" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="author" content="TR Assist" />
        <link rel="canonical" href="https://www.trassist.com.tr/blogs" />
        <link rel="alternate" hreflang="tr" href="https://www.trassist.com.tr/blogs" />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Tüm Blog Yazıları - TR Assist" />
        <meta property="og:description" content="TR Assist blog yazılarının tamamı. Yol yardım, sigorta, teknoloji, filo yönetimi ve daha fazlası hakkında uzman içerikler." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.trassist.com.tr/blogs" />
        <meta property="og:image" content="https://www.trassist.com.tr/img/tr_assistance_logo.svg" />
        <meta property="og:site_name" content="TR Assist" />
        <meta property="og:locale" content="tr_TR" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tüm Blog Yazıları - TR Assist" />
        <meta name="twitter:description" content="TR Assist blog yazılarının tamamı. Yol yardım, sigorta, teknoloji, filo yönetimi ve daha fazlası hakkında uzman içerikler." />
        <meta name="twitter:image" content="https://www.trassist.com.tr/img/tr_assistance_logo.svg" />
        
        {/* BreadcrumbList Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Ana Sayfa",
                "item": "https://www.trassist.com.tr"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Blog",
                "item": "https://www.trassist.com.tr/blogs"
              }
            ]
          })}
        </script>
        
        {/* Structured Data - Blog Collection */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "TR Assist Blog",
            "description": "Yol yardım, sigorta, teknoloji ve filo yönetimi hakkında uzman içerikler",
            "url": "https://www.trassist.com.tr/blogs",
            "publisher": {
              "@type": "Organization",
              "name": "TR Assist",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.trassist.com.tr/img/tr_assistance_logo.svg",
                "width": 600,
                "height": 60
              }
            },
            "blogPost": (blogs || []).map(blog => ({
              "@type": "BlogPosting",
              "headline": blog.title,
              "description": blog.excerpt,
              "url": `https://www.trassist.com.tr/blog/${blog.slug}`,
              "datePublished": blog.publishDate,
              "dateModified": blog.lastModified || blog.publishDate,
              "image": blog.image && blog.image.startsWith('http') ? blog.image : `https://www.trassist.com.tr${blog.image || '/img/about.jpg'}`,
              "author": {
                "@type": "Organization",
                "name": "TR Assist"
              },
              "publisher": {
                "@type": "Organization",
                "name": "TR Assist",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.trassist.com.tr/img/tr_assistance_logo.svg"
                }
              }
            }))
          })}
        </script>
      </Helmet>

      {/* Header */}
      <section className="blog-list-header">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <nav className="blog-breadcrumb">
                <Link to="/" className="breadcrumb-link">Ana Sayfa</Link>
                <span className="breadcrumb-separator">/</span>
                <span className="breadcrumb-current">Tüm Blog Yazıları</span>
              </nav>
              <h1>Tüm Blog Yazıları</h1>
              <p className="blog-list-desc">TR Assist'ten yol yardım, sigorta ve teknoloji alanındaki tüm yazılar</p>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="blog-list-content">
        <div className="container">
          <div className="row">
            {blogs && blogs.length > 0 ? (
              blogs.map((blog, index) => (
                <article key={`blog-${blog.slug}-${index}`} className="col-md-4 col-sm-6">
                  <div className="blog-item">
                    <div className="blog-image">
                      <img 
                        src={blog.image} 
                        className="img-responsive" 
                        alt={`${blog.title} - TR Assist Blog`}
                        onError={(e) => {
                          e.target.src = '/img/about.jpg';
                        }}
                      />
                      <div className="blog-date">
                        <span className="day">{blog.day}</span>
                        <span className="month">{blog.month}</span>
                      </div>
                      {blog.featured && (
                        <div className="blog-featured-badge">
                          <i className="fa fa-star"></i> Öne Çıkan
                        </div>
                      )}
                    </div>
                    <div className="blog-content">
                      <div className="blog-category">{blog.category}</div>
                      <h3>{blog.title}</h3>
                      <p>{blog.excerpt}</p>
                      <Link 
                        to={blog.link} 
                        className="btn btn-custom"
                        aria-label={`${blog.title} yazısını oku`}
                      >
                        Devamını Oku
                      </Link>
                    </div>
                  </div>
                </article>
              ))
            ) : (
              <div className="col-md-12">
                <p className="text-center">Blog yazıları yükleniyor...</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

